import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Cache } from 'aws-amplify';
import { Row, Col, Button, Spinner } from 'react-bootstrap';
import { fetchUsers, FINANCE_APPROVER, setUser } from '../../store/actions/users/usersActions';
import { addApprover, updateApprovers, upsertApprovers } from '../../store/actions/projects/projectApprovers';
import { clearSelectedUserOpt, toggleShowAlert, ERROR_ALERT } from '../../store/actions/commonActions';
import SelectUserField from '../../common/SelectUserField';
import DraggableList from '../../common/DraggableList';
import { APPROVED } from '../../store/actions/projects/projectsActions';

class ApprovalWorkflow extends Component {

  constructor(props) {
    super(props);
    this.state = {
      personas: []
    }
  }

  componentDidMount() {
    this.props.fetchUsers({is_disabled: 0});
  }
  
  displaySelectUser = () => {
    const userId = Cache.getItem('userId');
    let users = this.props.users.users;
    let approvers = this.props.projects.approvers;
    let arrApproverIds = [];

    if (approvers.length) {
      approvers.forEach(approver => {
        arrApproverIds.push(approver.id);
      })
    }
    //filter users
    users = users.filter(data => {
      //exclude non finance approvers 
      const isApprover = data.roles.filter(role => role.id === FINANCE_APPROVER).length;
      if (!isApprover) {
        return false;
      }
      if (!arrApproverIds.includes(data.id) && data.id !== userId) {
        return data;
      }
      return false;
    }).map(user => {
      return user;
    })

    const onChangeCallback = (value) => {
      if (value) {
        users.filter(data => {
          if (data.id === value.value) {
            return data;
          }
          return null;
        }).forEach(user => {
          this.props.setUser(user);
          Object.assign(user, {approver_id: user.id});
          this.props.addApprover(user);
          this.props.clearSelectedUserOpt();
        })
      }
    }

    return <SelectUserField 
      users={users} 
      selectOnce={true} 
      multiple={false} 
      fieldName="select_user" 
      onChangeCallback={onChangeCallback} 
    />
  }

  render() {

    if (this.props.project) {
      const project = this.props.project;
      if (project.is_disabled) {
        this.props.history.push('/projects/disabled');
        this.props.toggleShowAlert(true, ERROR_ALERT, 'You are not allowed to perform this action.');
      }
    }

    let approvers = this.props.projects.approvers;
    approvers = approvers.map(approver => {
      if (typeof(approver.title) === "undefined") {
        return {
          id: approver.approver_id, 
          approver_id: approver.approver_id, 
          title: approver.first_name + " " + approver.last_name
        }
      }
      return approver;
    })

    return (
      <>
        {!this.props.inWizard && <Row>
          <Col xs={10} sm={10} md={10} lg={10} xl={10}>
            <h6>Approvers</h6>
          </Col>
        </Row>}
        {!this.props.isImported && <hr />}
        <Row className="mt-3">
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="mb-3">
              Add Approver/s <span className='required-field'> * </span>
            </div>
            
            <Row>
              <Col>
                { this.displaySelectUser() } 
              </Col>
              <Col>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col xs={7} sm={7} md={7} lg={7} xl={7}>
            <DraggableList items={approvers} onDrag={(items) => {
              this.props.updateApprovers(items);
            }} onRemove={(items) => {
              this.props.updateApprovers(items);
            }}/>
            { (approvers.length > 0 && !this.props.isImported) 
              && <Button className="float-right" onClick={() => {
                this.props.upsertApprovers(APPROVED);
              }}>{this.props.common.isSaving ? <Spinner animation="border" size="sm" /> : "Save"}</Button> }
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  users: state.users,
  projects: state.projects,
  common: state.common 
})

const mapDispatchToProps = (dispatch) => {
  return {
    fetchUsers: (...args) => dispatch(fetchUsers(...args)),
    setUser: (...args) => dispatch(setUser(...args)),
    addApprover: (...args) => dispatch(addApprover(...args)),
    updateApprovers: (...args) => dispatch(updateApprovers(...args)),
    clearSelectedUserOpt: () => dispatch(clearSelectedUserOpt()),
    upsertApprovers: () => dispatch(upsertApprovers()),
    toggleShowAlert: (...args) => dispatch(toggleShowAlert(...args))
  }
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ApprovalWorkflow))